import AbstractModel from './AbstractModel'
import Column from './table/Column'

class TipoSegnalazione extends AbstractModel {
  permission () {
    return {
      'USR': {
        action: { isInsertable: false, isEditable: true, isDeletable: false },
        columns: {}
      },
      'ADM': {
        action: { isImpersonate: false, isInsertable: true, isEditable: true, isDeletable: true },
        columns: {}
      }
    }
  }
  columns () {
    return [
      new Column('btn').withHtml(true).withWidth('100px').withIsEditable(false).withIsInsertable(false).withExportable(false),
      new Column('tipo').withType('text'),
      new Column('dex').withType('text')
    ]
  }

  validator () {
    return {
      idazi: { required: true, type: 'number' },
      ambito: { required: true, type: 'string' },
      dexdpi: { required: true, type: 'string' },
      marcamodello: { required: true, type: 'string' },
      mansione: { required: true, type: 'string' },
      fattore: { required: true, type: 'string' }
    }
  }
}

export default new TipoSegnalazione()
